var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeague(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-football-ball",
    "data-name": "Icon awesome-football-ball",
    d: "M13.591,2.039A1.49,1.49,0,0,0,12.538.983,12.647,12.647,0,0,0,9.58.563L14,4.988a12.681,12.681,0,0,0-.409-2.95ZM.409,13.086a1.49,1.49,0,0,0,1.053,1.056,12.647,12.647,0,0,0,2.958.421L0,10.137A12.681,12.681,0,0,0,.409,13.086ZM.119,8.336l6.1,6.114a8.969,8.969,0,0,0,7.663-7.66L7.779.675A8.963,8.963,0,0,0,.119,8.336ZM9.075,4.847a.227.227,0,0,1,.319,0l.319.319a.227.227,0,0,1,0,.319l-.8.8.8.8a.227.227,0,0,1,0,.319l-.319.319a.227.227,0,0,1-.319,0l-.8-.8-.638.641.8.8a.227.227,0,0,1,0,.319L8.118,9A.227.227,0,0,1,7.8,9L7,8.2l-.638.638.8.8a.227.227,0,0,1,0,.319l-.319.319a.227.227,0,0,1-.319,0l-.8-.8-.8.8a.227.227,0,0,1-.319,0l-.319-.319a.227.227,0,0,1,0-.319l.8-.8-.8-.8a.227.227,0,0,1,0-.319L4.606,7.4a.227.227,0,0,1,.319,0l.8.8.638-.638-.8-.8a.227.227,0,0,1,0-.319l.319-.319a.227.227,0,0,1,.319,0l.8.8.638-.638-.8-.8a.227.227,0,0,1,0-.319l.319-.319a.227.227,0,0,1,.319,0l.8.8Z",
    transform: "translate(0 -0.563)",
    fill: "#868686"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeague);
export default __webpack_public_path__ + "static/media/league.61e4b309888bfad8e5468b205477bea7.svg";
export { ForwardRef as ReactComponent };